import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.css';
import lock from '../../assets/images/lock.png';
import key from '../../assets/images/key.png';
// import sandhi from '../../assets/images/sandhi.png';
import sandhi from '../../assets/images/pontis.png';
import backgroundGif from '../../assets/images/login.gif';
import bgVideo from '../../assets/images/test.mp4';
import passwordIcon from '../../assets/images/passwordIcon.svg';
import emailIcon from '../../assets/images/emailIcon.svg';
import './login.css';
import { LoginUserToServer } from '../../services/auth-service/authService.js';

function Login() {
    const navigate = useNavigate();
    const [image, changeBackGround] = useState(lock);
    const [emailAddress, setEmailAddress] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    

    // Email validation regex
    const validateEmailAddress = (inputData) => {
        var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if (inputData.match(validRegex)) {
            return true;
        } else {
            return false;
        }
    };

    // Navigate to ForgotPassword page
    function navigateToForgotPassword() {
        navigate('/ForgotPassword');
    };

    // Sign-in function
    function signIn() {
        if (!validateEmailAddress(emailAddress)) {
            alert("Email Address is not Valid. Please Enter a Valid Email Address!!!");
        } else {
            validateCredentials();
        }
    };

    // Validate credentials and make the API call
function validateCredentials() {
    let payload = {
        emailAddress: emailAddress,
        password: password
    }

    var loginUserCredentials = LoginUserToServer();

    axios.post(loginUserCredentials[1], payload, loginUserCredentials[0])
        .then(response => {
            console.log("Validate Credentials Response!!!", response);
            let responseData = response["data"];

            if (responseData["Status"] === "Success") {
                let userCredentials = responseData["user_credentials"];


                const passwordExpiry = new Date(userCredentials["user_password_expiry"]);
                const now = new Date();
                const new_user = userCredentials["user_new"]
                console.log("userCredentials !!!", userCredentials,new_user);
                if (passwordExpiry < now) {
                    alert("Your password has expired. Please reset your password.");
                    window.location.href = '/forgotpassword'; // change this to your actual forgot password route
                    return;
                }

if (String(new_user) === 'true') {
    alert("Please reset your password.");
    window.location.href = '/forgotpassword';
    return;
}
                sessionStorage.setItem("userCredentials", JSON.stringify(userCredentials));
                window.location.href = '/landing_page';
            }
        }).catch(error => {
            console.log("Error", error);
            alert("Error in Login User!!!");
        });
}

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();  // Prevent the form submission
            signIn();  // Call the sign-in function
        }
    };

    return (
        <div className="containers">
            {/* <img src={image} alt="No Images" style={{ width: '1536px', height: '761px' }} /> */}
            <video
    className="bg-video"
    autoPlay
    loop
    muted
    playsInline
>
    <source src={bgVideo} type="video/mp4" />
    Your browser does not support the video tag.
</video>
{/* <img
    src={backgroundGif}
    alt="Background"
    className="bg-image"
/> */}
            <div className="design-scale">
  <div className="design-root">

            <div className="box"></div>
            <div>
                <img src={sandhi} className="imgsandhi1" alt="sandhi" />
                <form className="main-form">
                    <label htmlFor="email" className="emailid">User ID</label>
                    <input
                        type="email"
                        id="email"
                        name="emailAddress"
                        className="emailidinput"
                        value={emailAddress}
                        onClick={() => changeBackGround(lock)}
                        onChange={(e) => { setEmailAddress(e.target.value) }}
                        onKeyDown={handleKeyPress}  // Add the keydown event here
                    />
                    <div className="emailicon">
                        <img src={emailIcon} alt="email" />
                    </div>
                    <label htmlFor="Pwd" className="password">Password</label>
                    <input
                        type={showPassword ? "text" : "password"}
                        id="Pwd"
                        name="password"
                        className="passwordinput"
                        value={password}
                        onClick={() => changeBackGround(key)}   // background change stays
                        onChange={(e) => setPassword(e.target.value)}
                        onKeyDown={handleKeyPress}
                    />

                    <div
                        className="passwordicon"
                        onMouseDown={(e) => {
                            e.preventDefault();     // stop focus/background click
                            setShowPassword(true);  // show password
                        }}
                        onMouseUp={() => setShowPassword(false)}      // hide again
                        onMouseLeave={() => setShowPassword(false)}   // hide if cursor leaves
                        onTouchStart={() => setShowPassword(true)}    // mobile support
                        onTouchEnd={() => setShowPassword(false)}
                    >
                        <img src={passwordIcon} alt="show password" />
                    </div>

                    <div className="topnav">
                        <input type="checkbox" name="" className="checkbox-1 " />
                        <span className="top-left">Remember Me</span>
                        <p id="forgot-password-id" className="top-right" onClick={navigateToForgotPassword}>Forgot Password?</p>
                    </div>
                    <input type="button" value="Login" className="loginbtn" onClick={signIn} />
                </form>
            </div>
        </div>
                    </div>
        </div>
    );
}

export default Login;